import React, { useState, useEffect } from 'react';
import { FaGithub } from 'react-icons/fa';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 1rem 0;
  transition: background-color 0.3s ease;
  background-color: ${({ scrolled }) => scrolled ? 'rgba(18, 18, 18, 0.95)' : 'transparent'};
  backdrop-filter: ${({ scrolled }) => scrolled ? 'blur(10px)' : 'none'};
  box-shadow: ${({ scrolled }) => scrolled ? '0 2px 10px rgba(0, 0, 0, 0.2)' : 'none'};
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const Logo = styled.div`
  font-family: 'Orbitron', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--secondary);
  display: flex;
  align-items: center;

  span {
    color: var(--primary);
  }
`;

const Nav = styled.nav`
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.a`
  color: var(--text-primary);
  font-weight: 500;
  position: relative;
  transition: color 0.3s ease;

  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -5px;
    left: 0;
    background-color: var(--secondary);
    transition: width 0.3s ease;
  }

  &:hover {
    color: var(--secondary);
    
    &:after {
      width: 100%;
    }
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

const GitHubButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: #171515;
  color: white;
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 1px solid #333;

  &:hover {
    background-color: #333;
    transform: translateY(-2px);
  }
`;

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <HeaderContainer scrolled={scrolled}>
      <HeaderContent>
        <Logo>
          RIFT: <span>Last One</span>
        </Logo>

        <Nav>
          <NavLink href="#about">About</NavLink>
          <NavLink href="#features">Features</NavLink>
          <NavLink href="#monetization">Monetization</NavLink>
        </Nav>

        <ButtonsContainer>
          <GitHubButton href="https://github.com/lastone-games/" target="_blank" rel="noopener noreferrer">
            <FaGithub /> GitHub
          </GitHubButton>
        </ButtonsContainer>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
